module.exports = __webpack_public_path__ + "images/five-year-club-4f6aeb634d54b98ec2b2e98c799e99a5.png";